import { BaseRepository } from "repositories/BaseRepository";

export class ConversationsRepository extends BaseRepository {
  constructor(db) {
    super(db, "conversations");
  }

  async getPendingMessagesCount() {
    return this.tx("readonly", async (store) => {
      let total = 0;

      return new Promise((resolve, reject) => {
        const cursor = store.openCursor();

        cursor.onsuccess = (e) => {
          const c = e.target.result;
          if (!c) return resolve(total);

          const value = c.value;
          total += value.newMessages ?? 0;
          c.continue();
        };

        cursor.onerror = () => reject(cursor.error);
      });
    });
  }

  async getByLineIdStatus(lineId, status) {
    return this.where("lineId_status").eq([lineId, status]);
  }

  async getByLineIdUserId(lineId, userId) {
    return this.where("lineId_userId").eq([lineId, userId]);
  }

  async getByLineIdUserIdStatus(lineId, userId, status) {
    return this.where("lineId_status").eq([lineId, status]).then((conversations) => {
      return conversations.filter((conversation) => {
        return conversation?.userId === userId;
      });
    });
  }
}
